// copied from https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/

const bodyEl = document?.querySelector("body");
let scrollPosition = 0;

export const enable = () => {
  if (bodyEl) {
    const scrollbarWidth =
      (window?.innerWidth || bodyEl?.offsetWidth) - bodyEl?.clientWidth;
    scrollPosition = window?.pageYOffset ?? 0;
    bodyEl.style.overflowY = "hidden";
    bodyEl.style.position = "fixed";
    bodyEl.style.top = `-${scrollPosition}px`;
    bodyEl.style.width = "100%";
    bodyEl.style.paddingRight = `${scrollbarWidth}px`;
  }
};

export const disable = () => {
  if (bodyEl) {
    bodyEl.style.overflowY = "auto";
    bodyEl?.style?.removeProperty("position");
    bodyEl?.style?.removeProperty("top");
    bodyEl?.style?.removeProperty("width");
    bodyEl.style?.removeProperty("padding-right");
    window?.scrollTo(0, scrollPosition);
  }
};

export const setInitialDocumentOverFlow = () => {
  if (document?.documentElement) {
    document.documentElement.style.overflow = "visible";
  }
};

export const removePointerEvents = () => {
  if (bodyEl) {
    bodyEl?.style?.removeProperty("pointer-events");
  }
};

export function getScrollbarWidth(): number {
  if (typeof window === "undefined" || !bodyEl) return 0;
  return (window.innerWidth || bodyEl.offsetWidth) - bodyEl.clientWidth;
}
